<template>
    <div class="text-center">
        <vue-paginator
            :pagination="pagination.status"
            :options="pagination.options"
            :callback="load"
        ></vue-paginator>
    </div>
</template>

<script type="text/babel">
import pagination from 'vue-bootstrap-pagination'

export default {
    components: {
        'vue-paginator': pagination,
    },
    props: ['pagination'],

    methods: {
        load(data) {
            this.$emit('load', data)
        },
    },
}
</script>
